import moment from 'moment';

export default {
	sharingWithMeEmails: state => state.sharingWithMeEmails,
	message: state => state.message,
	userSharingEmails: state => state.userSharingEmails,
	profile: state => state.profile,
	loading: state => state.loading,
	users: state => {
		if (state.users) {
			return state.users.sort((u1, u2) => {
				const createAt1 = new Date(parseInt(u1._id.toString().slice(0, 8), 16) * 1000);
				const createAt2 = new Date(parseInt(u2._id.toString().slice(0, 8), 16) * 1000);
				if (moment(createAt1).isSameOrBefore(createAt2)) return 1;
				else return -1;
			});
		} else state.users;
	},
	invoice: state => state.invoice,
	profileUser: state => state.profileUser,
	globalLoading: state => state.globalLoading,
};
